<template>
  <div class="mall-round-button" @click="$emit('click')">
    <span class="mall-round-button__text">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'MallRoundButton',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
/* Figma 기준 높이 28px (테두리 포함) */
.mall-round-button {
  display: flex;
  flex-shrink: 0;
  padding: 5px 11px;
  justify-content: center;
  align-items: center;
  border: 1px solid #D1D6DB;
  border-radius: 10000px;
  background: #FFF;
  cursor: pointer;
}

.mall-round-button__text {
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-xxs);
  font-weight: var(--font-weight-medium);
  line-height: 16px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallRoundButton.vue